import { useEffect, useState } from "react";
import styled from "styled-components";
import store from "../../../_services/store";
import { ArrowContainer, Card, CardHeader, LabelDate, LabelName } from "../news/components";
import { displayDate } from "../../../_services/utils/utils";
import { ReactComponent as ArrowIcon } from '../../../assets/svg/right-arrow.svg';
import { ReactComponent as SearchLogo } from "../../../assets/svg/search.svg";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../router/routes";
import { NewsBadge } from "./components";
import labels from '../../../_translations/accueil.json';
import { Container } from "../informations/components";
import { CardTitle, Header, Image, PageTitle, SearchInput, SearchInputContainer } from "../../_ui";
import { MoleculeCard } from "../molecules/components";
import { observer } from "mobx-react";


const HomeLogoFooter = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 20px 180px; /* remonté au-dessus du bottom nav */

  @media (min-width: 768px) {
    padding: 30px 20px 90px;
  }
`;

const HomePage = observer(() => {
  const [searchValue, setSearchValue] = useState<string>("");
  const [articles, setArticles] = useState<TArticle[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if(!store.authToken) return;

    if (store.articles.length === 0) {
      store.getArticles();
    }

    if (store.moleculesList.length === 0) {
      store.getMolecules();
    }

    if (store.symptomesList.length === 0) {
      store.getSymptomes();
    }
    store.getMoleculesStats();
    store.getSymptomsStats();
  }, [store.authToken]);

  useEffect(() => {
    setArticles(store.articles);
  }, [store.articles]);

  const prepareSearchData = (data: (TMolecule| TSymptome)[]) => {    
      return data?.filter((mol: TMolecule) => (searchValue.length > 0) && mol.title.toLowerCase().includes(searchValue));
  }
  
  const molecules = prepareSearchData([...(store.moleculesList || []), ...(store.symptomesList || [])]) || [];

  const openArticle = (id: string) => {
    navigate(ROUTES.ARTICLE(id));
  }

  const searchForCriteria = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const article = articles?.[0];

  const articleElement = (article &&
    <div className="fadeIn" style={{ padding: 0, margin: 0 }}>
      <NewsBadge>{labels[store.currentLanguage].label.actutitle}</NewsBadge>
      <Card key={`card_${article.title}`} onClick={() => openArticle(article.id.toString())} >
        <CardHeader>
          <Image style={{ borderRadius: '50%' }} src="/images/news2.jpeg" width="auto" height="100px" />
          <div style={{ maxWidth: '400px', marginLeft: '20px' }}>
            <CardTitle>{article.title}</CardTitle>
            <LabelDate>{displayDate(article.updated_at)}</LabelDate>
          </div>
        </CardHeader>
        <ArrowContainer>
          <ArrowIcon />
        </ArrowContainer>
      </Card>
    </div>
  )

  const isSearching = searchValue.trim().length > 0;

  return (
    <div className="fadeIn" style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <Header bgUrl={"/images/bg-home.jpeg"}>
        <PageTitle>{labels[store.currentLanguage].title}</PageTitle>
        <SearchInputContainer>
          <SearchLogo />
          <SearchInput
            type="text"
            placeholder={labels[store.currentLanguage].search}
            onChange={searchForCriteria}
          />
        </SearchInputContainer>
      </Header>

      <Container>
        {!isSearching && articleElement}
        <div>
          {molecules?.map(e => <div key={`molecule_${e.id}`} style={{marginBottom: '20px'}}><MoleculeCard key={`Section_${Object.keys(e)[0]}`} molecule={e} /></div>)}
        </div>
      </Container>

      {!isSearching && (
        <HomeLogoFooter>
          <img
            src="/images/logo_avene2.png"
            alt="Avène"
            style={{ maxWidth: 280, maxHeight: 100, width: 'auto', height: 'auto', objectFit: 'contain' }}
          />
        </HomeLogoFooter>
      )}
    </div>
  )
});

export default HomePage;